/** Shared layout tokens for material line items. */
export const MATERIAL_ROW = {
    px: { xs: 2, sm: 3 },
    nestedPx: { xs: 1.5, sm: 2 },
    nestedMx: { xs: 1.5, sm: 2 },
} as const;

const MATERIAL_BORDER_WIDTH = "1px";
const MATERIAL_ACCENT_WIDTH = "2px";

export const materialGlassPanelSx = {
    borderRadius: 0,
    border: `${MATERIAL_BORDER_WIDTH} solid`,
    borderColor: "rgba(128, 128, 128, 0.2)",
    bgcolor: "rgba(128, 128, 128, 0.05)",
    backdropFilter: "blur(12px)",
    overflow: "hidden",
} as const;

export const materialNestedGroupSx = {
    mx: MATERIAL_ROW.nestedMx,
    my: 1.25,
    border: `${MATERIAL_BORDER_WIDTH} solid`,
    borderColor: "divider",
    borderLeft: `${MATERIAL_ACCENT_WIDTH} solid`,
    borderLeftColor: "primary.500",
    borderRadius: 0,
    bgcolor: "background.surface",
    overflow: "hidden",
} as const;

export const materialSubgroupBandSx = {
    px: MATERIAL_ROW.nestedPx,
    py: 0.75,
    bgcolor: "background.level1",
    borderBottom: `${MATERIAL_BORDER_WIDTH} solid`,
    borderColor: "divider",
} as const;

export const materialRowDividerSx = {
    borderBottom: `${MATERIAL_BORDER_WIDTH} solid`,
    borderColor: "divider",
} as const;

export const materialRowTopDividerSx = {
    borderTop: `${MATERIAL_BORDER_WIDTH} solid`,
    borderColor: "divider",
} as const;

/** Max width for formula tooltips on material/labor line items. */
export const formulaTooltipMaxWidth = "min(1000px, 90vw)";
